import { Measure } from '../common/measure';
import { DIM2CLASS } from '../core/icon-class';

require('./filter-drilldown.component.scss');

class FilterDrilldownController {
  constructor(
    $scope,
    CurrentFilterService,
    RouterService,
    CurrentModelService,
  ) {
    this.$scope = $scope;
    this.getMeasure = Measure.getMeasure;
    this.getMeasureLabel = Measure.getMeasureLabel;
    this.getMeasures = Measure.getMeasures;
    this.DIM2CLASS = DIM2CLASS;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
  }

  get filter() {
    return this.CurrentFilterService.filter;
  }

  get visibleDimensions() {
    return this.CurrentFilterService.visibleDimensions;
  }

  get model() {
    return this.CurrentModelService.model;
  }
}

export const FilterDrilldownComponent = {
  template: require('./filter-drilldown.component.html'),
  bindings: {},
  controller: FilterDrilldownController,
};



// WEBPACK FOOTER //
// ./src/filter/filter-drilldown.component.js